import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { IpConfirmActionDialogComponent } from 'src/app/invopay/components/ip-confirm-action-dialog/ip-confirm-action-dialog.component';
import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';
import { TableEvent } from 'src/app/shared/components/table/Itable';

@Component({
  selector: 'app-fn-account-transactions',
  templateUrl: './fn-account-transactions.component.html',
  styleUrls: ['./fn-account-transactions.component.scss'],
})
export class FnAccountTransactionsComponent implements OnInit {
  @Input() selectedSupplierId?: number;
  @Output() changedData = new EventEmitter();
  type!: 'business' | 'employee' | 'provider';
  tableOptions!: TableOption;
  private dataChangeSubject: Subject<void> = new Subject<void>();
  dataChange: Observable<void> = this.dataChangeSubject.asObservable();
  propertyOrder: string[] = [];

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private roleService: IpRoleService,
    private translateService: TranslateService,
    private ipSnackbarService: IpSnackbarService
  ) {}

  ngOnInit(): void {
    this.type = this.roleService.getType();

    this.propertyOrder = this.setProperty();
    const statuses: Array<[string, string]> = [];
    statuses.push(['IP.TABLE.SELECT.ALL', '']);
    this.tableOptions = {
      keyTranslate: this.setKeyTranslate(),
      selects: statuses,
      actions: this.setActions(),
      filters: this.setFilters(),
    };
  }

  setProperty(): string[] {
    return ['dateTime', 'movementType', 'description', 'amount'];
  }

  setKeyTranslate(): string {
    return 'IP.TABLE.ACCOUNT-TRANSACTIONS';
  }

  setActions(): Array<string> {
    return [];
  }

  setFilters(): Array<[string, string]> {
    switch (this.type) {
      case 'business':
      case 'provider':
        return [['IP.TABLE.DASHBOARD.FILTER.DATE-ISSUED', 'date']];
      default:
        return [];
    }
  }

  async onAction(tableEvent: TableEvent) {
    switch (tableEvent.event) {
      default:
        console.warn(
          `Handler for action "${tableEvent.event}" was not defined.`
        );
        break;
    }
  }

  private async showConfirmActionDialog(
    id: string,
    action: string
  ): Promise<boolean> {
    let questionText = '';
    if (action === 'delete') {
      questionText = 'IP.CONFIRM-ACTION-DIALOG.DELETE-TEXT';
    } else if (action === 'report') {
      questionText = 'IP.CONFIRM-ACTION-DIALOG.REPORT-TEXT';
    }
    const dialogRef = this.dialog.open(IpConfirmActionDialogComponent, {
      data: {
        id,
        question: this.translateService.instant(questionText),
      },
    });
    return firstValueFrom(dialogRef.afterClosed());
  }
}
